/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtResponse } from '../../models/ot-response';

export interface GetOtById$Params {
  /**
   * Id de l'ot
   */
  idOt: string;
}

export function getOtById(
  http: HttpClient,
  rootUrl: string,
  params: GetOtById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<OtResponse>> {
  const rb = new RequestBuilder(rootUrl, getOtById.PATH, 'get');
  if (params) {
    rb.path('idOt', params.idOt, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OtResponse>;
    })
  );
}

getOtById.PATH = '/v2/ots/{idOt}';
